'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["hasClearButton", "required", "value", "domRef", "handleClear", "onChange", "id", "name", "children", "label", "hasBorder", "hasFloatedLabel", "hasVisibleLabel", "icon", "instruction", "invalid", "placeholder", "disabled", "readOnly", "predictiveText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var localizationContext = require('@shared-ui/localization-context');
var React = require('react');
var field = require('@egds/react-core/field');
var icons = require('@egds/react-core/icons');
var utils = require('@egds/react-core/utils');
var styles = require('../styles/egds-search-experience-typeahead-custom-text-input.css');
function _interopDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styles__default = /*#__PURE__*/_interopDefault(styles);
var getClassNameList = utils.classNames.bind(styles__default["default"]);
var TypeaheadCustomTextInput = function TypeaheadCustomTextInput(props) {
  var _props$hasClearButton = props.hasClearButton,
    hasClearButton = _props$hasClearButton === void 0 ? false : _props$hasClearButton,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    _props$domRef = props.domRef,
    inputRef = _props$domRef === void 0 ? React__namespace.createRef() : _props$domRef,
    onClear = props.handleClear,
    onChange = props.onChange,
    id = props.id,
    name = props.name,
    children = props.children,
    label = props.label,
    hasBorder = props.hasBorder,
    hasFloatedLabel = props.hasFloatedLabel,
    _props$hasVisibleLabe = props.hasVisibleLabel,
    hasVisibleLabel = _props$hasVisibleLabe === void 0 ? false : _props$hasVisibleLabe,
    icon = props.icon,
    instruction = props.instruction,
    invalid = props.invalid,
    placeholder = props.placeholder,
    disabled = props.disabled,
    readOnly = props.readOnly,
    predictiveText = props.predictiveText,
    attributes = _objectWithoutProperties(props, _excluded);
  var l10n = localizationContext.useLocalization();
  var _React__namespace$use = React__namespace.useState(predictiveText),
    _React__namespace$use2 = _slicedToArray(_React__namespace$use, 2),
    predictiveTextValue = _React__namespace$use2[0],
    setPredictiveTextValue = _React__namespace$use2[1];
  React__namespace.useEffect(function () {
    setPredictiveTextValue(predictiveText);
  }, [predictiveText, predictiveTextValue]);
  var handleClear = function handleClear() {
    var _inputRef$current;
    onChange === null || onChange === void 0 || onChange({
      target: {
        value: '',
        name: name
      }
    });
    inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    onClear === null || onClear === void 0 || onClear();
    setPredictiveTextValue('');
  };
  var showClearButton = hasClearButton && !!value;
  var fieldPropsClassNames = getClassNameList(showClearButton && 'has-typeahead-custom-text-input-cta');
  var fieldProps = {
    labelClassName: fieldPropsClassNames,
    disabled: disabled,
    hasBorder: hasBorder,
    hasFloatedLabel: hasFloatedLabel,
    hasVisibleLabel: hasVisibleLabel,
    icon: icon,
    id: id,
    instruction: instruction,
    invalid: invalid,
    label: label,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required
  };
  var cssClassNames = getClassNameList('uitk-field-input', showClearButton && 'has-typeahead-custom-text-input-cta', 'typeahead-custom-text-input');
  var labelFieldTextForIcon = function () {
    if (React__namespace.isValidElement(label)) {
      var _labelProps$children;
      var labelProps = label.props;
      return (_labelProps$children = labelProps === null || labelProps === void 0 ? void 0 : labelProps.children) !== null && _labelProps$children !== void 0 ? _labelProps$children : '';
    }
    return label;
  }();
  var clearText = l10n.formatText('clear');
  var iconTitle = showClearButton ? [clearText, labelFieldTextForIcon].join(' ') : '';
  return React__namespace.createElement(field.EGDSField, _objectSpread({}, fieldProps), React__namespace.createElement("input", _objectSpread(_objectSpread({}, attributes), {}, {
    value: value,
    onChange: onChange,
    className: cssClassNames,
    "aria-describedby": invalid ? "".concat(id, "-error") : undefined,
    placeholder: placeholder,
    ref: inputRef,
    id: id,
    "aria-required": required,
    "aria-invalid": !!invalid,
    type: "text"
  })), children, predictiveTextValue && React__namespace.createElement("input", _objectSpread(_objectSpread({}, attributes), {}, {
    className: getClassNameList('predictive-text', 'uitk-field-input', showClearButton && 'has-typeahead-custom-text-input-cta', 'typeahead-custom-text-input'),
    value: predictiveTextValue,
    readOnly: true
  })), showClearButton && React__namespace.createElement("button", {
    className: getClassNameList('uitk-clear-button', 'typeahead-custom-text-input-cta'),
    onClick: handleClear,
    type: "button"
  }, React__namespace.createElement(icons.EGDSIcon, {
    name: "cancel",
    size: icons.EGDSIconSize.SMALL,
    title: iconTitle,
    id: "".concat(id, "-clear-input-button")
  })));
};
TypeaheadCustomTextInput.displayName = 'TypeaheadCustomTextInput';
exports.TypeaheadCustomTextInput = TypeaheadCustomTextInput;
//# sourceMappingURL=index-chunk.js.map
